import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const CalendarInputRoot = styled.div`
  position: relative;
  width: 100%;
`;

export const CalendarPopup = styled.div<{
  $top: number;
  $left: number;
  $ready: boolean;
}>`
  position: fixed;
  /*
    top/left приходят из getBoundingClientRect и уже заданы в физических
    координатах viewport. Здесь намеренно не используется pxToRem.
  */
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $left }) => `${$left}px`};
  z-index: 1100;
  width: max-content;
  max-width: calc(100vw - ${pxToRem(32)});
  visibility: ${({ $ready }) => ($ready ? "visible" : "hidden")};
`;